import Slide from '../components/Slide';
import { upgradeSystem } from '../data/pages';

export default function System() {
  const { dataKey, heading, options } = upgradeSystem;
  return <Slide dataKey={dataKey} heading={heading} options={options} />;
}
